export default __webpack_public_path__ + "static/media/male_idle_lod.f4d894bf.glb";